// extracted by mini-css-extract-plugin
export default {"wrapper":"pWCbs34Fp1mtQgBYsuql","icon":"NLNVubB6xVEj8_PEs_ic","title":"U4ryArO0dKUYN3X9Gurc","subtitle":"MCkunByWj_s6RDdXMvXN"};